/* eslint-disable */
import qs from 'qs';
import cx from 'classnames';
import changeCase from 'change-object-case';
import moment from 'moment';
import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux'
import { ss, mapDispatch, navTo, numberWithCommas, setToken } from '../utils/util';
import { Alert, Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import FontAwesome from 'react-fontawesome';
import Dropzone from 'react-dropzone';
import Papa from 'papaparse';

import { GOOGLE_SHEETS_REDIRECT } from '../config';

import OzComponent from '../lib/OzComponent';
import Wrapper from './Wrapper';
import './Spreadsheet.css';
import OzTabs from '../lib/OzTabs';
import OzPills from './partials/OzPills';
import WhereField from './partials/WhereField';
import LeaderboardStats from './partials/LeaderboardStats';
import RegisterForm from './partials/RegisterForm';
import OmniField from './partials/OmniField';

import { PercentBar } from './partials/ReviewItem';
import {
  login,
  register,
  fetchUser,
  upload,
  uploadUnauth,
  importEscapes,
  importEscapesUnauth,
  getProfile,
  excelToRows,
  pullSheetsFromGoogle,
  pullGoogleSheet,
} from '../actions';


class Spreadsheet extends OzComponent {

  static need = [
    ['user', fetchUser],
  ]

  state = {
    offset: 0,
    limit: 50,
    cols: {},
    override: {},
    trans: {},
  };

  constructor(props) {
    super(props);
    // let hash = window.location.hash;
    // if (hash.length > 1) {
    //   this.state.tab = 'google';
    // }
  }

  componentWillMount() {
    let hash = null;
    try {
      hash = window.location.hash;
    } catch (e) {};
    if (hash && hash.length > 1) {
      let query = hash.slice(1);
      let params = qs.parse(query);
      // navTo('/sh');
      this.setState({ accessToken: params.access_token, tab: 'google' });
      this.props.pullSheetsFromGoogle({ accessToken: params.access_token })
        .then(resp => {
          console.log('google resp', resp);
          this.setState({ googleSheets: resp.spreadsheets });
        });
    }
  }

  clear() {
    if (!confirm("Are you sure you want to start over?")) return;

    this.setState({
      rows: null,
      sheets: null,
    })
  }

  setCol(colNum, value) {
    let cols = Object.assign({}, this.state.cols);
    for (let key of Object.keys(cols)) {
      if (cols[key] == value) {
        cols[key] = '';
      }
    }
    cols[colNum] = value;
    console.log('set cols', cols);

    if (value == 'rating' && this.state.skipEmptyRating == undefined) {
      this.setState({
        skipEmptyRating: true,
        skipEmptyRatingPill: 't',
      });
    }

    this.setState({ cols: cols });
  }

  handleReadFile(file, data) {
    console.log('data:', data);

    let fn = (this.props.isLoggedIn
            ? this.props.upload
            : this.props.uploadUnauth);

    fn({ file: data })
      .then(resp => {
        console.log('upload resp', resp);
        console.log('upload file type:', file.type);
        let excelTypes = [
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        ];

        let isExcel = (
          excelTypes.includes(file.type) ||
          (file.type.indexOf('excel') != -1) ||
          (file.name.endsWith('.xls')) ||
          (file.name.endsWith('.xlsx'))
        );

        if (isExcel) {
          this.props.excelToRows({ url: resp.url })
            .then(resp => {
              console.log('excel resp:', resp);
              if (resp.error) {
                this.setState({ excelError: true });
              } else {
                this.setState({ sheets: resp.sheets, excelError: false });
              }
            })
        }
        this.setState({ csv: resp.url });
      });
  }

  parse(csv) {
    Papa.parse(csv, {
	    complete: (results) => {
		    console.log("Finished:", results);
        this.setState({ rows: results.data });
	    }
    });
  }

  parseText() {
    this.parse(this.state.text);
  }

  readFile(file) {
    if (file.type == 'text/csv') {
      this.parse(file);
    }

    console.log('file', file);
    let reader = new FileReader();
    reader.onload = (e) => {
      if (e.target.readyState == 2) {
        console.log('e', e);
        this.handleReadFile(file, e.target.result);
      }
    };
    reader.readAsDataURL(file);
  }

  onDrop(accepted, rejected) {
    if (!(accepted && accepted.length == 1)) {
      alert('Error with file upload!');
      return;
    }
    let file = accepted[0];
    this.readFile(file);
  }

  runImport(preview) {
    let serverTrans = [];
    for (let key of Object.keys(this.state.trans)) {
      serverTrans.push({
        value: key,
        outcome: this.state.trans[key] == '1',
      })
    }

    let limit;
    let offset;
    if (preview) {
      offset = this.state.offset;
      limit = this.state.limit;
    } else {
      offset = 0;
      limit = 1000;
    }
    let rows = this.state.rows.slice(offset, offset + limit);

    let params = {
      offset,
      limit,
      rows,
      cols: this.state.cols,
      header: this.state.header,
      skipEmpty: this.state.skipEmptyRating ? 'rating' : null,
      override: this.state.override,
      trans: serverTrans,
      preview,
    };

    console.log('preview for params:', params);

    if (!preview && !this.props.isLoggedIn) {
      this.setState({ registerForImport: true });
    } else {
      let fn = (this.props.isLoggedIn
              ? this.props.importEscapes
              : this.props.importEscapesUnauth);
      fn(params)
        .then(resp => {
          console.log('preview import:', resp);
          this.setState({ preview: resp });
          if (!preview) {
            this.props.getProfile(this.props.user.username)
              .then(() => {
                alert('Running import, it will be done in a few seconds or minutes. It takes about 10 seconds per 100 rows.');
                navTo('/p/' + this.props.user.username)}
              );
          }
        });
    }
  }

  renderControls() {
    if (!this.state.rows) return;

    let required = [
      'room',
      // 'company',
    ];

    let haveRequired = true;
    for (let r of required) {
      let found = false;
      for (let v of Object.values(this.state.cols)) {
        if (v == r) {
          found = true;
        }
      }
      if (!found) {
        haveRequired = false;
      }
    }

    if (!haveRequired) {
      return (
        <div className="controls">
          Required columns: {required.join(', ')}
        </div>
      )
    }

    let importNode = null;
    if (this.state.preview) {
      let count = 0;

      for (let rowNum = 0; rowNum < this.state.rows.length; rowNum++) {
        let row = this.state.rows[rowNum];
        let override = this.state.override[rowNum] || [];
        // if (override.skip) continue;
        let skip = override.skip;
        if (this.state.skipEmptyRating) {
          console.log('skip empty?', this.state.cols, row);
          for (let key of Object.keys(this.state.cols)) {
            if (this.state.cols[key] == 'rating') {
              if (!row[key]) {
                skip = true;
              }
            }
          }
        }
        if (skip) continue;
        count++;
      }

      importNode = (
        <div className="import-wrapper">
          <Button bsSize="large" bsStyle="primary" onClick={() => this.runImport(false)}>Import {count} escape{count == 1 ? '' : 's'}</Button>
        </div>
      );
    }

    return (
      <div className="controls">
        <Button bsSize="large" bsStyle="default" onClick={() => this.runImport(true)}>Preview Import</Button>
        {importNode}
      </div>
    )
  }

  badMatch(item) {
    this.setState({
      showOmniFor: item,
      manual: {
        roomName: item.inputData.room,
        company: item.inputData.company,
        city: item.inputData.city,
      }
    })

    // console.log('bad match:', item);
    // let override = Object.assign({}, this.state.override);
    // override[item.rowNum] = {
    //   noMatch: true,
    // };
    // this.setState({ override });
  }

  skipRow(item) {
    let override = Object.assign({}, this.state.override);
    override[item.rowNum] = {
      skip: true,
    };
    this.setState({ override });
  }

  unSkipRow(item) {
    let override = Object.assign({}, this.state.override);
    override[item.rowNum] = {
      skip: false,
    };
    this.setState({ override });
  }

  getDetail(item, key) {
    // console.log('GET DETAIL', item, key);
    let override = this.state.override[item.rowNum] || {};
    return override[key] == undefined ? item[key] : override[key];
  }

  setDetail(item, key, value, cb) {
    console.log('SET DETAIL', item, key, value);
    let override = Object.assign({}, this.state.override);
    let rowOverride = Object.assign({}, override[item.rowNum] || {});
    rowOverride[key] = value;
    override[item.rowNum] = rowOverride;
    this.setState({ override });
  }

  renderEditDetailsNode(item) {
    let didEscape = this.getDetail(item, 'didEscape');
    let didEscapeKey = didEscape ? 'true' : 'false';

    let date = this.getDetail(item, 'date');
    if (date) {
      date = moment(date, 'YYYY-MM-DD');
    }
    let time = this.getDetail(item, 'time');
    let timeNode;
    if (time) {
      timeNode = (
        <div>
          {time.minutes} minutes{' '}
          {!!time.seconds && '' + time.seconds + ' seconds'}
        </div>
      );
    }

    let rating = this.getDetail(item, 'rating');
    let ratingNode;
    if (rating) {
      ratingNode = <PercentBar percent={rating} />;
    }

    return (
      <div className="edit-details">
        <div className="did-escape">
          <div>Did you escape?</div>
          <div>
            <OzPills value={didEscapeKey}>
              <div key="true" onClick={() => this.setDetail(item, 'didEscape', true)}>yes!</div>
              <div key="false" onClick={() => this.setDetail(item, 'didEscape', false)}>no...</div>
            </OzPills>
          </div>
        </div>
        <div className="time">
          {timeNode}
        </div>
        <div className="date">
          {!!date && <SingleDatePicker
           date={date}
           onDateChange={d => {
             this.setDetail(item, 'date', d.format('YYYY-MM-DD'))
           }}
           focused={this.state.focused == item.rowNum}
           onFocusChange={({ focused }) => {
                         if (focused) {
                           this.setState({ focused: item.rowNum })
                         } else {
                           this.setState({ focused: false })
                         }
           }}
           id={item.rowNum}
           numberOfMonths={1}
           small={true}
           isOutsideRange={(day) => false}
           />}
        </div>
        <div className="rating">
          {ratingNode}
        </div>
      </div>
    )
  }

  renderPreview() {
    if (!this.state.preview) return;
    if (!this.state.rows) return;

    let nodes = this.state.preview.items.map(item => {
      let matchNode = null;

      let escapeNode = null;
      if (item.escape) {
        escapeNode = (
          <div className="preview-already-added">Already added</div>
        );
      }

      let skipNode = (
        <div>
          <Button bsSize="xs" onClick={() => this.skipRow(item)}>Skip this row</Button>
        </div>
      );
      let unSkipNode = (
        <div>
          <Button bsSize="xs" onClick={() => this.unSkipRow(item)}>Actually, import it!</Button>
        </div>
      );
      let badMatchNode = (
        <div>
          <Button bsSize="xs" onClick={() => this.badMatch(item)}>Bad Match, Let Me Fix It!</Button>
        </div>
      );


      let rowOverride = this.state.override[item.rowNum] || {};
      let skip = rowOverride.skip;
      let noMatch = !item.room || (rowOverride.noMatch && !skip);

      let roomOverride = null;
      if (rowOverride.roomId) {
        roomOverride = {};
        roomOverride.roomId = rowOverride.roomId;
        roomOverride.name = rowOverride.room;
        roomOverride.company = rowOverride.company;
      } else if (rowOverride.room && rowOverride.company) {
        roomOverride = {};
        roomOverride.name = rowOverride.room;
        roomOverride.company = rowOverride.company;
        roomOverride.city = rowOverride.city;
      }

      // console.log('rowOverride', rowOverride, item);
      // console.log('roomOverride::', roomOverride);

      let editDetailsNode = this.renderEditDetailsNode(item);

      if (roomOverride) {
        matchNode = (
          <div>
            <div className="preview-match-info">
              <div className="preview-match-room">{roomOverride.name}</div>
              <div className="preview-match-company">{roomOverride.company}</div>
              <div className="preview-match-city">{roomOverride.city}</div>
            </div>

            {editDetailsNode}
            <div className="row-controls">
              {badMatchNode}
              {skipNode}
            </div>
          </div>
        );
      } else if (skip) {
        matchNode = (
          <div>
            <div>Skipping this row.</div>
            <div className="row-controls">
              {unSkipNode}
            </div>
          </div>
        );
      } else if (noMatch) {
        matchNode = (
          <div>
            <div>No match, will import as a new room.</div>

            {editDetailsNode}
            <div className="row-controls">
              {badMatchNode}
              {skipNode}
            </div>
          </div>
        );
      } else if (item.room) {
        let match = item.room;

        matchNode = (
          <div>
            <div className="preview-match-info">
              <div className="preview-match-room">{match.name}</div>
              <div className="preview-match-company">{match.location && match.location.company}</div>
              <div className="preview-match-city">{match.location && match.location.city.name}</div>
            </div>
            {escapeNode}

            {!escapeNode && editDetailsNode}
            <div className="row-controls">
              {!escapeNode && badMatchNode}
              {!escapeNode && skipNode}
            </div>
          </div>
        );
      }

      let offset = 0;
      if (this.state.header) {
        offset = 1;
      }
      let row = this.state.rows[item.rowNum + offset];
      console.log('this.state.rows', this.state.rows, row, item.rowNum);
      let c = 0
      let rowAllCellNodes = row.map(cell => {
        let col = this.state.cols[c];
        let header = col;
        if (!col && this.state.header) {
          header = this.state.rows[0][c];
        }
        c++;
        return (
          <div className={cx({ used: !!col })}>{!!header && <span className="header">{header}: </span>}{cell}</div>
        );
      });

      return (
        <div key={item.rowNum}  className={cx('preview-item', { 'has-data': !skip, 'no-match': noMatch, 'room-override': roomOverride })}>
          <div className="preview-input">
            <div className="input-cells">{rowAllCellNodes}</div>
          </div>
          <div className={cx('preview-match')}>
            {matchNode}
          </div>
        </div>
      )
    });

    return (
      <div className="preview">
        <h2>Preview</h2>
        <div className="preview-items">
          {nodes}
        </div>
      </div>
    )
  }

  setTrans(userValue, value) {
    let trans = Object.assign({}, this.state.trans);
    trans[userValue] = value;
    this.setState({ trans });
  }

  renderTable() {
    if (!this.state.rows) return;

    let rows = this.state.rows.slice(0, 8);

    let columnOptions = [
      ['', ''],
      ['room', 'Room (required)'],
      ['company', 'Company'],
      ['city', 'City'],
      ['outcome', 'Did you escape?'],
      ['time', 'Time to escape'],
      // ['remaining', 'Remaining time'],
      ['date', 'Date of escape'],
      ['rating', 'Rating'],
      // ['photo', 'Photo URL'],
    ];

    let headerNodes = [];
    let numCells = rows[0].length;
    for (let i = 0; i < numCells; i++) {
      let fieldName = 'col' + i;
      let selectNode = (
        <FormControl
          componentClass="select"
          value={this.state.cols[i]}
          onChange={(e) => this.setCol(i, e.target.value)}
          >
          {columnOptions.map(o => <option key={o[0]} value={o[0]}>{o[1]}</option>)}
        </FormControl>
      )

      let node = (
        <th key={i}>
          {selectNode}
        </th>
      );
      headerNodes.push(node);
    }
    let header = <tr key="header">{headerNodes}</tr>;

    let rowNum = 0;
    let rowNodes = rows.map(row => {
      let cellNum = 0;
      let isHeader = rowNum == 0 && this.state.header;

      let cells = row.map(cell => <td className={cx({'has-name': !isHeader && this.state.cols[cellNum]})} key={cellNum++}>{cell}</td>);
      return <tr className={cx({'is-header' : isHeader})} key={rowNum++}>{cells}</tr>;
    });

    let table = (
      <Table>
        <thead>{header}</thead>
        <tbody>{rowNodes}</tbody>
      </Table>
    );

    let outcomeColNum = null;
    console.log('???', this.state.cols, Object.keys(this.state.cols));
    for (let colNum of Object.keys(this.state.cols)) {
      let colName = this.state.cols[colNum];
      console.log('?? col', colNum, colName);
      if (colName == 'outcome') {
        outcomeColNum = colNum;
      }
    }

    console.log('!! outcomeColNum', outcomeColNum);
    let didEscapeNode;
    if (outcomeColNum) {
      let outcomeValues = {};
      for (let row of this.state.rows) {
        outcomeValues[row[outcomeColNum]] = true;
      }

      let options = [
        ['', ''],
        ['1', 'This means I escaped'],
        ['0', 'This means I did NOT escape'],
      ];
      let trans = this.state.trans;
      console.log('TRANS', trans);

      let nodes = Object.keys(outcomeValues).map(val => {
        return (
          <div key={val} className="outcome-value">
            <div className="user-outcome">{val}</div>
            <div className="translated-outcome">
              <FormControl
                componentClass="select"
                value={trans[val]}
                onChange={(e) => this.setTrans(val, e.target.value)}
              >
                {options.map(option => <option key={option[0]} value={option[0]}>{option[1]}</option>)}
              </FormControl>
            </div>
          </div>
        )
      });

      didEscapeNode = (
        <div className="option">
          <div className="q">What does "Did escape" column mean?</div>
          <div className="a">
            <div className="outcome-config">
              {nodes}
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="table">
        <div className="table-config">
          <div className="option">
            <div className="q">Is the first row a header?</div>
            <div className="a">
              <OzPills value={this.state.headerPill}>
                <div key="t" onClick={() => this.setState({ header: true, headerPill: 't' })}>yes</div>
                <div key="f" onClick={() => this.setState({ header: false, headerPill: 'f' })}>no</div>
              </OzPills>
            </div>
          </div>

          <div className="option">
            <div className="q">Skip if rating is empty?</div>
            <div className="a">
              <OzPills value={this.state.skipEmptyRatingPill}>
                <div key="t" onClick={() => this.setState({ skipEmptyRating: true, skipEmptyRatingPill: 't' })}>yes</div>
                <div key="f" onClick={() => this.setState({ skipEmptyRating: false, skipEmptyRatingPill: 'f' })}>no</div>
              </OzPills>
            </div>
          </div>

          {didEscapeNode}
        </div>

        <div className="table-wrapper">
          {table}
        </div>
      </div>
    )
  }

  handlePickRoom(result) {
    console.log('handlePickRoom', result);
    this.setState({
      omniPick: result,
    });
  }

  commitOmni() {
    let item = this.state.showOmniFor;

    let override = Object.assign({}, this.state.override);
    let rowOverride = Object.assign({}, override[item.rowNum] || {});
    // rowOverride[key] = value;

    if (this.state.omniPick) {
      rowOverride.roomId = this.state.omniPick.id;
      rowOverride.room = this.state.omniPick.roomName;
      rowOverride.company = this.state.omniPick.secondary;
    } else {
      rowOverride.room = this.state.manual.roomName;
      rowOverride.company = this.state.manual.company;
      rowOverride.city = this.state.manual.cityName;
    }

    override[item.rowNum] = rowOverride;
    this.setState({ override });
    this.setState({ showOmniFor: null });
  }

  setManual(field, value) {
    let manual = Object.assign({}, this.state.manual);
    manual[field] = value;
    this.setState({ manual });
  }

  renderOmniModal() {
    let manual = this.state.manual || {};

    let manualNode = (
      <div className="manual-entry">
        <p>Or enter it manually:</p>
        <div className="manual-field">
          <label>Room:</label>
          <input
            type="text"
            value={manual.roomName || ''}
            onChange={(e) => this.setManual('roomName', e.target.value)}
          />
        </div>
        <div className="manual-field">
          <label>Company:</label>
          <input
            type="text"
            value={manual.company || ''}
            onChange={(e) => this.setManual('company', e.target.value)}
          />
        </div>
        <div className="manual-field">
          <label>City:</label>
          <input
            type="text"
            value={manual.cityName || ''}
            onChange={(e) => this.setManual('cityName', e.target.value)}
          />
        </div>
      </div>
    );

    let omniPickNode;
    if (this.state.omniPick) {
      omniPickNode = (
        <div className="omni-pick">
          <div className="omni-info">
            <div className="name">{this.state.omniPick.roomName}</div>
            <div className="company">{this.state.omniPick.secondary}</div>
          </div>

          <div className="omni-change">
            <Button bsSize="small" onClick={() => this.setState({ omniPick: null })}>Change</Button>
          </div>
        </div>
      );
    }

    let commitNode;
    let manualOk = manual.roomName && manual.company;
    if (this.state.omniPick || manualOk) {
      commitNode = (
        <div className="commit">
          <Button bsSize="large" bsStyle="primary" onClick={() => this.commitOmni()}>Done</Button>
        </div>
      )
    }

    return (
      <Modal show={!!this.state.showOmniFor}>
        <Modal.Header>Pick room</Modal.Header>
        <Modal.Body>
          <div className="spreadsheet-pick-room">
            <p>Search for the room:</p>
            <OmniField
              prefill="Find room to add..."
              showTypes={['rooms']}
              onResult={(result) => this.handlePickRoom(result)}
            />

            {this.state.omniPick && omniPickNode}
            {!this.state.omniPick && manualNode}
            {commitNode}
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  didRegister() {
    alert('Success!\n\nYour import should be done in a few seconds or minutes. Refresh the page to check progress.');
    this.setState({ registerForImport: false });
    this.runImport(false);
  }

  renderRegisterModal() {
    return (
      <Modal show={this.state.registerForImport}>
        <Modal.Header>Sign up</Modal.Header>
        <Modal.Body>
          <RegisterForm
            doRegister
            values={{}}
            errors={this.props.errors.register}
            buttonText="Save Your Escapes"
            onSuccess={() => this.didRegister()}
          />
        </Modal.Body>
      </Modal>
    );
  }

  renderUpload() {
    return (
      <div className="upload-area">
        <input ref="upload" name="upload" type="file" accept="*" onChange={(e) => this.readFile(e.target.files[0])}/>

        <Dropzone
          className="drop"
          activeClassName="drop-active"
          acceptClassName="drop-accept"
          onDrop={(a, r) => this.onDrop(a, r)}><span>Drag file here to upload</span></Dropzone>
      </div>
    );
  }

  renderTextArea() {
    return (
      <div className="text-escape-input">
        <FormControl
          componentClass="textarea"
          placeholder="Paste your escapes here, one line per escape"
          value={this.state.text}
          onChange={ss(this, 'text')}
        />
        <Button onClick={() => this.parseText()}>Continue</Button>
      </div>
    )
  }

  renderSheetPicker() {
    let sheetNames = Object.keys(this.state.sheets);
    let nodes = sheetNames.map(name => {
      let delta = {
        sheetName: name,
        rows: this.state.sheets[name],
      };
      return (
        <div key={name} onClick={() => this.setState(delta)}>{name}</div>
      );
    });

    return (
      <div className="sheet-picker">
        <h3>Please pick a sheet from the workbook</h3>
        <OzPills value={this.state.sheetName}>
          {nodes}
        </OzPills>
      </div>
    );
  }

  generateGoogleUrl() {
    let endpoint = 'https://accounts.google.com/o/oauth2/v2/auth';
    let params = {
      client_id: '73377597242-6i64i8737uq4lt4lhbbt3i33n0ei77fr.apps.googleusercontent.com',
      redirect_uri: GOOGLE_SHEETS_REDIRECT,
      response_type: 'token',
      scope: 'https://www.googleapis.com/auth/spreadsheets.readonly https://www.googleapis.com/auth/drive.readonly',
    };
    return endpoint + '?' + qs.stringify(params);
  }

  pullSheet(id) {
    console.log('pullSheet', id);
    this.props.pullGoogleSheet({ accessToken: this.state.accessToken, sheet: id })
      .then(resp => {
        this.setState({ sheets: resp.sheets, googleSheets: null });
      });
  }

  renderGoogle() {
    let googleUrl = this.generateGoogleUrl();
    console.log('googleUrl', googleUrl);

    if (this.state.googleSheets) {
      let nodes = this.state.googleSheets.map(sheet => {
        return (
          <div className="google-sheet" onClick={() => this.pullSheet(sheet.id)}>
            {sheet.title}
          </div>
        )
      });

      return (
        <div className="google-sheets">{nodes}</div>
      );
    } else {
      return (
        <div className="google">
          <div className="google-primary">
            <p>You can import a spreadsheet from Google. Click the button below to give EscapeSpy access to your files on Google.</p>
            <a href={googleUrl}><Button bsStyle="primary" bsSize="large">Import From Google Sheets</Button></a>
          </div>

          <div className="google-fallback">
            <p>If you don't want to give EscapeSpy access, you can also export it yourself:
              <ul>
                <li>Open the spreadsheet in Google Sheets</li>
                <li>Click <b>File</b> &gt; <b>Download</b> &gt; <b>Microsoft Excel (.xls)</b></li>
                <li>Import that into EscapeSpy using the <b>Upload File</b> tab</li>
              </ul>
            </p>
          </div>
        </div>
      )
    }
  }

  setOffset(offset) {
    this.setState({ offset: parseInt(offset) }, () => this.runImport(true));
  }

  renderPager() {
    if (!this.state.rows) return;
    if (!this.state.preview) return;

    let numPages = Math.floor(this.state.rows.length / this.state.limit) + 1;
    let options = [];
    for (let i = 0; i < numPages; i++) {
      options.push([i * this.state.limit, 'Page ' + (i+1)]);
    }

    return (
      <FormControl
        componentClass="select"
        value={this.state.offset}
        onChange={(e) => this.setOffset(e.target.value)}
      >
        {options.map(option => <option key={option[0]} value={option[0]}>{option[1]}</option>)}
      </FormControl>
    );
  }

  render() {
    let noFile = !this.state.rows && !this.state.sheets;

    return (
      <Wrapper className="Spreadsheet" title="Escapes Bulk Import">
        <div className="content">
          <p><b>Do you track your escapes in a spreadsheet?</b> You can import it into EscapeSpy! Use our tool to easily track dozens or hundreds of escapes that you already have in a spreadsheet.</p>

          <p>Pick the type of spreadsheet you have, and then fill out the form to import all your escapes.</p>

          {this.state.excelError && <Alert bsStyle="danger">It looks like you uploaded an Excel file, but I couldn't understand it. Our monkeys are investigating now!</Alert>}

          {noFile && <OzTabs tab={this.state.tab}>
           <div tabKey="upload" tabName="Upload File">{this.renderUpload()}</div>
           <div tabKey="copypaste" tabName="Copy/Paste Text">{this.renderTextArea()}</div>
           <div tabKey="google" tabName="Import from Google Sheets">{this.renderGoogle()}</div>
           </OzTabs>}

          {!noFile && <div className="change-file">
           <Button onClick={() => this.clear()}>Change File</Button>
          </div>}

          {this.state.sheets && this.renderSheetPicker()}

          {this.renderOmniModal()}
          {this.renderRegisterModal()}

          {this.renderTable()}

          {this.renderControls()}

          {this.renderPager()}
          {this.renderPreview()}
          {this.renderPager()}

        </div>
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    isLoggedIn: state.isLoggedIn,
    user: state.user,
    errors: state.errors,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    login,
    register,
    fetchUser,
    upload,
    uploadUnauth,
    importEscapes,
    importEscapesUnauth,
    getProfile,
    excelToRows,
    pullSheetsFromGoogle,
    pullGoogleSheet,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Spreadsheet);



/** WEBPACK FOOTER **
 ** ./src/components/Spreadsheet.js
 **/